import { render, staticRenderFns } from "./ResultVotesPoints.vue?vue&type=template&id=115ea51d"
import script from "./ResultVotesPoints.vue?vue&type=script&lang=js"
export * from "./ResultVotesPoints.vue?vue&type=script&lang=js"
import style0 from "./ResultVotesPoints.vue?vue&type=style&index=0&id=115ea51d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports